import {useEffect, useState} from "react";
import {useSelector} from "react-redux";
import InstrumentIcon from "../../../../components/instrument-icon";
import Big from "big.js";
import {useLocation, useSearchParams} from "react-router-dom";
import {useTranslation} from "react-i18next";
import FormButton from "../../../../components/form-button";
import associateServices from "../../../../services";
import InputMask from "react-input-mask";
import {toast} from "react-toastify";
import MATH_HELPER from "../../../../helpers/math-helper";
import TipCurrencyDropdown from "./currency-dropdown";
import {decrypt, encrypt} from "../../../../helpers/encryption";

const INITIAL_STATE = {
    otp: '',
    code: '',
    username: '',
    amount: '',
    isPublic: '',
    secret: '',
}
const TipModal = () => {
    const {
        currencyList,
        currencies,
        selectedWallet,
        lastChatLanguage,
        selectedFiat
    } = useSelector(state => state.authenticationReducer)
    const {modalCurrency} = useSelector(state => state.globalReducer)


    const [submitting, setSubmitting] = useState(false)
    const [enabled, setEnabled] = useState(false)
    const [searchParams, setSearchParams] = useSearchParams()
    const {t} = useTranslation()
    const [selectedCurrency, setSelectedCurrency] = useState({})
    const [step, setStep] = useState('form')
    const [tipInstance, setTipInstance] = useState(INITIAL_STATE)
    const [regex] = useState(new RegExp("^\\d{1,8}(\\.\\d{0," + 8 + "})?$"))

    const location = useLocation()
    const getParams = (key) => {
        const searchParams = new URLSearchParams(location?.search);
        return searchParams.get(key);
    }

    useEffect(() => {

        const uu = getParams('user')
        if (uu && uu !== 'undefined')
            handleChange('username', uu)


    }, [location?.search])

    useEffect(() => {
        handleChange('code', selectedCurrency?.code)
    }, [selectedCurrency])

    const handleChangeWallet = wall => {

        // setTheNetwork('')
        setSearchParams({
            modal: 'wallet',
            tab: 'tip',
            currency: wall.code,
        })

        const instances = currencies?.filter(ioi => ioi.alias === wall?.code)

        if (instances)
            setSelectedCurrency(wall)

    }

    useEffect(() => {
        if (modalCurrency) {
            const theWalletMe = currencyList.find(i => i.code === modalCurrency)
            setSelectedCurrency(theWalletMe)

        } else if (selectedWallet?.code) {
            const theWalletMe = currencyList.find(i => i.code === selectedWallet?.code)
            setSelectedCurrency(theWalletMe)
        }
    }, [selectedWallet, modalCurrency])


    const handleReset = () => {
        setTipInstance(INITIAL_STATE)
        setStep('form')
    }

    useEffect(() => {
        if (step === 'form')
            setEnabled(parseFloat(tipInstance?.amount || 0) > 0 && tipInstance?.username && tipInstance?.code)
        else
            setEnabled(tipInstance.otp && tipInstance.otp?.toString()?.length === 6)
    }, [tipInstance, step])


    const handleTip = () => {
        setSubmitting(true)
        if (!MATH_HELPER.isNumeric(tipInstance.amount))
            return toast.error(t(`general.enter-a-valid-amount`))


        // todo get curreny amount !!!


        let amount = tipInstance.amount
        if (selectedFiat)
            amount = Big(tipInstance.amount || 0).times(rates[selectedCurrency?.code] || 0).toFixed(8)


        associateServices.tip({...tipInstance, amount, language: lastChatLanguage}).then(res => {
            setSubmitting(false)

            if (res?.status !== 200)
                return toast.error(t(`api-notifications.${res?.errors}`))

            if (step === 'form') {
                if (res?.data?.step === 'email' || res?.data?.step === '2factor') {
                    setStep(res?.data?.step || '')
                    handleChange('secret', res?.data?.secret)
                }
            } else {
                handleReset()

                searchParams.delete('modal')
                searchParams.delete('tab')
                searchParams.delete('currency')
                searchParams.delete('user')
                searchParams.delete('username')
                setSearchParams(searchParams)
            }


        })
    }

    const handleChange = (type, value) => {
        if (type === 'amount') {
            value = value?.replace(/,/g, '.')
            if (value === '' || regex.test(value)) {
                setTipInstance(prevState => ({
                    ...prevState,
                    [type]: value
                }))
            }
        } else
            setTipInstance(prevState => ({
                ...prevState,
                [type]: value
            }))
    }


    const [rates, setRates] = useState({})
    useEffect(() => {

        if (selectedFiat) {

            const handleFiatRates = e => {
                const data = decrypt(e)
                setRates(data)
            }
            window?.tcpSocket?.emit('fiat:rate', encrypt({
                currency: selectedFiat
            }))

            window?.tcpSocket?.on('fiat:rates', handleFiatRates)


        }

    }, [selectedFiat])


    const getDisplayCurrency = () => {
        if (!selectedFiat)
            return `${Big(tipInstance?.amount || 0).toFixed(8)} ${selectedCurrency?.code}`


        return `${Big(tipInstance.amount || 0).times(rates[selectedCurrency?.code] || 0).toFixed(8)} ${selectedCurrency?.code}`
    }


    const handleSetMax = () => {
        console.log('selectedCurrency = ', selectedCurrency)
        console.log(rates[selectedCurrency?.code])
        if (!selectedFiat)
            return handleChange('amount', Big(selectedCurrency?.balance || 0).toFixed(8))

        return handleChange('amount', Big(selectedCurrency.balance || 0).div(rates[selectedCurrency?.code] || 0).toFixed(2))


    }
    return (
        <>


            <div className="modal__form">

                {
                    step === 'form' ? <>
                            <div className="modal__drops">


                                <TipCurrencyDropdown selectedCurrency={selectedCurrency}
                                                     handleChangeWallet={handleChangeWallet}
                                                     currencyList={currencyList}/>
                            </div>

                            <div className="modal__drops">
                                <div className="form__group ">
                                    <label htmlFor="" className="form__label">
                                        {t('tip.name')} <b>*</b>
                                    </label>
                                    <input
                                        value={tipInstance.username}
                                        onChange={e => handleChange('username', e.target.value)}
                                        type="text" className="form__input"/>
                                </div>
                            </div>
                            <div className="form__group">
                                <label htmlFor="" className="form__label form__label--max med">
                                    {t('tip.amount')} <b>*</b> <span>
                                    {getDisplayCurrency()}
                                </span>
                                </label>
                                <div className="form__amount">


                                    <input
                                        disabled={step !== 'form'}
                                        className="form__input"
                                        maxLength={24}
                                        type="number"
                                        value={tipInstance.amount || ''}
                                        onChange={e => handleChange('amount', e.target.value)}
                                        pattern="[0-9]*"
                                        inputMode="numeric"
                                    />

                                    <div className="form__coin">
                                        <InstrumentIcon code={selectedFiat || selectedCurrency?.code}/>
                                    </div>
                                    <button
                                        onClick={handleSetMax}
                                        className="form__max" type="button">
                                        {t('tip.max')}
                                    </button>
                                </div>
                            </div>
                            <div className="form__switch">
                                <input
                                    checked={tipInstance.isPublic}
                                    onChange={e => handleChange('isPublic', e.target.checked)}
                                    type="checkbox"
                                    className="form__switch-input"
                                    name="switch0"
                                    id="switch0"
                                />
                                <label htmlFor="switch0">
                                    <p>{t('tip.public')}</p>
                                    <span>{t('tip.public-description')}</span>
                                </label>
                            </div>
                        </> :

                        <>
                            <div className="form__group">
                                <label htmlFor="" className="form__label form__label--max med">
                                    {t('tip.amount')} <b>*</b>
                                    <span className="d-flex align-items-center gap-2">
                                    <InstrumentIcon code={selectedCurrency?.code}/>
                                        {getDisplayCurrency()}
                                    </span>
                                </label>

                            </div>
                            <div className="form__group">
                                <label htmlFor="" className="form__label">
                                    {t(`general.enter-otp-code-${step}`)} <b>*</b>
                                </label>
                                <InputMask
                                    mask={'999999'}
                                    maskPlaceholder={null}
                                    disabled={step === 'form'}
                                    className="form__input"
                                    value={tipInstance.otp || ''}
                                    onChange={e => handleChange('otp', e.target.value)}
                                    type="text" // Set type to text
                                    inputMode="numeric" // Hint for numeric keyboard
                                />
                            </div>
                        </>

                }


                <FormButton
                    label={t('tip.button')}
                    loading={submitting}
                    disabled={!enabled}
                    onClick={handleTip}
                />

            </div>
        </>
    )

}


export default TipModal
